import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { PayOffList, PayOffUnprocessedElapse, PayOffUnprocessedCarryOver, PayOffDetail, PayOffDaily } from './components';
import { NotificationActions, PayOffListActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;

const PayOff = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const payOffListActions = bindActionCreators(PayOffListActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const [modeInfo, setModeInfo] = useState({ mode: 'list', merchant_name: '', merchant_type: '', fixed_dt: '', payment_cycle: '', nengappi: '' });
    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    /**
     *
     * 精算リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showList = () => {
        setListRefresh(false);
        setModeInfo({ mode: 'list', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, fixed_dt: modeInfo.fixed_dt, payment_cycle: modeInfo.payment_cycle, nengappi: modeInfo.nengappi });
    }

    /**
     *
     * 精算日別画面表示
     *
     * @param data 選択された行のデータ
     * @param fixedDt 確定日（yyyy/mm/dd）
     * @param paymentCycle 精算サイクル（1:月１回/2:月２回/3:月４回）
     */
    const showDateList = (data, fixedDt, paymentCycle) => {
        setModeInfo({ mode: 'datelist', merchant_name: data.merchant_name, merchant_type: data.merchant_type_name, fixed_dt: fixedDt, payment_cycle: paymentCycle, nengappi: '' });
    }

    /**
     *
     * 精算詳細画面表示
     *
     * @param data 選択された行のデータ
     * @param nengappi 選択された日付（yyyy/mm/dd）
     */
    const showDetail = (data, nengappi) => {
        setModeInfo({ mode: 'detail', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, fixed_dt: modeInfo.fixed_dt, payment_cycle: modeInfo.payment_cycle, nengappi: nengappi });
    }

    /**
     *
     * 精算日別画面表示（精算詳細画面から戻り用）
     *
     * @param data 選択された行のデータ
     */
    const showDateListForDetail = (data) => {
        setModeInfo({ mode: 'datelist', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, fixed_dt: modeInfo.fixed_dt, payment_cycle: modeInfo.payment_cycle, nengappi: modeInfo.nengappi });
    }

    /**
     *
     * 精算未了（過去分）画面表示
     *
     * @param data 選択された行のデータ
     * @param fixedDt 確定日（yyyy/mm/dd）
     */
    const showElapse = (data, fixedDt) => {
        setModeInfo({ mode: 'elapse', merchant_name: data.merchant_name, merchant_type: data.merchant_type_name, fixed_dt: fixedDt, payment_cycle: '', nengappi: '' });
    }

    /**
     *
     * 精算未了（繰越分）画面表示
     *
     * @param data 選択された行のデータ
     * @param fixedDt 確定日（yyyy/mm/dd）
     */
    const showCarryOver = (data, fixedDt) => {
        setModeInfo({ mode: 'carryover', merchant_name: data.merchant_name, merchant_type: data.merchant_type_name, fixed_dt: fixedDt, payment_cycle: '', nengappi: '' });
    }

    var listClass = classes.hiddenList;

    if (modeInfo.mode == 'list') {
        // 精算一覧画面表示
        listClass = classes.visibleList;
    }

    var content = <div></div>;

    if (modeInfo.mode == 'datelist') {
        // 精算日別画面表示
        content = <PayOffDaily onCancel={showList} onDetail={showDetail} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} fixedDt={modeInfo.fixed_dt} paymentCycle={modeInfo.payment_cycle} />
    }
    if (modeInfo.mode == 'detail') {
        // 精算詳細画面表示
        content = <PayOffDetail onCancel={showDateListForDetail} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} fixedDt={modeInfo.fixed_dt} paymentCycle={modeInfo.payment_cycle} nengappi={modeInfo.nengappi} />
    }
    if (modeInfo.mode == 'elapse') {
        // 精算未了（過去分）画面表示
        content = <PayOffUnprocessedElapse onCancel={showList} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} fixedDt={modeInfo.fixed_dt} />
    }
    if (modeInfo.mode == 'carryover') {
        // 精算未了（繰越分）画面表示
        content = <PayOffUnprocessedCarryOver onCancel={showList} merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} fixedDt={modeInfo.fixed_dt} />
    }
 
    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <PayOffList onDetail={showDateList} onElapse={showElapse} onCarryOver={showCarryOver} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(PayOff);
